import { render, staticRenderFns } from "./RegistyShiftsManager.vue?vue&type=template&id=7a26f704"
import script from "./RegistyShiftsManager.vue?vue&type=script&lang=js"
export * from "./RegistyShiftsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports